import { NgModule } from "@angular/core";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { CommonModule } from "@angular/common";
import { PopoverModule } from "../s25-popover/popover.module";
import { FormsModule } from "@angular/forms";
import { S25NavBarComponent } from "./s25.nav.bar.component";
import { S25ViewerMessageComponent } from "../s25-viewer-message/s25.viewer.message.component";
import { S25RouterLinkDirective } from "./s25.router.link.directive";
import { S25MoreMenuComponent } from "./more-menu/s25.more.menu.component";
import { S25MasqueradeModule } from "../S25-masquerade/masquerade.module";
import { AdmitModule } from "../admit/admit.module";
import { S25MoreMenuItemComponent } from "./more-menu/s25.more.menu.item.component";
import { S25HelpDirective } from "../s25-help/s25.help.directive";
import { S25ClickOutsideDirective } from "../s25-click-outside/s25.click.outside.directive";

@NgModule({
    imports: [
        S25LoadingInlineModule,
        CommonModule,
        PopoverModule,
        FormsModule,
        S25IconComponent,
        S25ViewerMessageComponent,
        S25RouterLinkDirective,
        S25MasqueradeModule,
        AdmitModule,
        S25ClickOutsideDirective,
        S25MoreMenuItemComponent,
        S25HelpDirective,
    ],
    exports: [S25NavBarComponent, S25MoreMenuComponent],
    declarations: [S25NavBarComponent, S25MoreMenuComponent],
    providers: [S25NavBarComponent, S25MoreMenuComponent],
})
export class S25NavBarModule {}
